import React, { MouseEventHandler } from 'react';
import usePaginaPago from 'src/reducers/PaginaPago/usePaginaPago';
import { Layout } from '../styleds';

export type GenericButtonType = {
  img?: {
    src: string;
    alt?: string;
    onClick: MouseEventHandler;
  };
  onClick?: MouseEventHandler;
  icon?: any;
  text?: any;
  children?: any;
};

const GenericButton: React.FC<GenericButtonType> = ({ img, children, onClick, icon, text }) => {
  const { valdiarTerminos } = usePaginaPago();
  console.log("valdiarTerminos:", img, valdiarTerminos.toString())
  return (
    <Layout onClick={onClick}>
      <div className="d-flex flex-row text-primary">
        {img && (
          <img
            onClick={valdiarTerminos(img?.onClick)}
            className="logo"
            style={{ width: '180px', height: '50px' }}
            src={img?.src}
            alt={img?.alt}
            {...img}
          />
        )}
        {children}
        {icon} {text}
      </div>
    </Layout>
  );
};

export default GenericButton;
